module.exports = __webpack_public_path__ + "img/footer_bg.45cd76a7.jpg";